//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import checker from "../Checker";
import CustomChecker from "@/components/CustomChecker";
export default {
    name: "payMethod",
    components: {
        checker,
        CustomChecker,
    },
    props: {
        type: {
            type: String,
        },
        isVip: {
            type: Boolean,
            default: false,
        },
        isChecked: {
            type: Boolean,
            default: false,
        },
        showIcon: {
            type: Boolean,
            default: true,
        },
        aliPayTags: {},
    },
    computed: {
        info() {
            const infos = {
                wechat: {
                    text: "微信支付",
                    cls: "wechat-icon",
                },
                alipay: {
                    text: "支付宝支付",
                    cls: "alipay-icon",
                },
                friendPay: {
                    text: "找朋友帮忙还",
                    cls: "friend-pay",
                },
                offlinePay: {
                    text: "线下还款",
                    cls: "offline-pay",
                },
            };
            return infos[this.type] || {};
        },
    },
};
